import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardMetricItem from '@components/pages/Dashboard/DashboardMetricItem.component'
import DashboardSharedTable from '@components/pages/Dashboard/Shared/DashboardSharedTable'
import type { UseProceduresResult } from '@hooks/dashboard/useProcedures'
import { PROCEDURES_TABLE_COLUMNS } from '@constants/Dashboard/proceduresDashboard.constants'
import { metricDataToItemProps } from '@utils/dashboardMetrics.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'

type ProceduresCardProps = {
  titleHref: string
  procedures: UseProceduresResult
}

export function ProceduresCard({
  titleHref,
  procedures,
}: ProceduresCardProps): React.ReactElement {
  const { cardMetrics, cardTableRows, loading, hasData, hasPayload } =
    procedures
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Procedures"
      titleHref={titleHref}
      className="dashboard-procedures-card"
      loading={pending}
      skeleton={{ metrics: 4, metricColumns: 4, block: 'tall' }}
      isEmpty={isEmpty}
      disableTitleLink={isEmpty}
    >
      <div className="dashboard-procedures-content">
        <div className="dashboard-procedures-metrics">
          {cardMetrics.map((m) => (
            <DashboardMetricItem
              key={m.id ?? m.leftLabel}
              {...metricDataToItemProps(m)}
            />
          ))}
        </div>
        <div className="dashboard-procedures-table-wrap">
          <DashboardSharedTable
            loading={loading}
            showSearchFilter={false}
            columns={[...PROCEDURES_TABLE_COLUMNS]}
            data={cardTableRows}
            showPagination={false}
          />
        </div>
      </div>
    </DashboardSectionCard>
  )
}
